import { render } from "./SpeakingTest.vue?vue&type=template&id=3f8279e9&scoped=true"
import script from "./SpeakingTest.vue?vue&type=script&lang=js"
export * from "./SpeakingTest.vue?vue&type=script&lang=js"

import "./SpeakingTest.vue?vue&type=style&index=0&id=3f8279e9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8279e9"]])

export default __exports__